
import React from 'react';

interface WatermarkOverlayProps {
  children: React.ReactNode;
  showWatermark: boolean;
  brand?: string;
}

export const WatermarkOverlay: React.FC<WatermarkOverlayProps> = ({ 
  children, 
  showWatermark, 
  brand = 'GENOVA AI STUDIO' 
}) => {
  if (!showWatermark) {
    return <>{children}</>;
  }

  return (
    <div className="relative">
      {children}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Subtle diagonal repeating watermark pattern */}
        <div className="absolute inset-0">
          {Array.from({ length: 12 }).map((_, i) => (
            <div
              key={i}
              className="absolute text-white/[0.06] font-medium text-lg whitespace-nowrap select-none"
              style={{
                transform: `rotate(-45deg) translateY(${i * 160}px)`,
                left: '-20%',
                top: '-10%',
                width: '140%',
                letterSpacing: '0.1em',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
              }}
            >
              {Array.from({ length: 3 }).map((_, j) => (
                <span key={j} className="inline-block mx-32">
                  {brand}
                </span>
              ))}
            </div>
          ))}
        </div>
        
        {/* Modern premium center watermark badge */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div className="bg-gradient-to-br from-purple-600/95 to-pink-600/95 text-white px-8 py-4 rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.3)] border-2 border-white/30">
            <div className="text-center">
              <div className="font-bold text-xl mb-1 tracking-wide" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
                {brand}
              </div>
              <div className="text-[10px] opacity-90 font-medium tracking-wide">
                Upgrade to Pro
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
